import { render, staticRenderFns } from "./ContactTeamItem.vue?vue&type=template&id=5fa3d232&"
import script from "./ContactTeamItem.vue?vue&type=script&lang=js&"
export * from "./ContactTeamItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fa3d232')) {
      api.createRecord('5fa3d232', component.options)
    } else {
      api.reload('5fa3d232', component.options)
    }
    module.hot.accept("./ContactTeamItem.vue?vue&type=template&id=5fa3d232&", function () {
      api.rerender('5fa3d232', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/sidebar/nav-menu-items/ContactTeamItem.vue"
export default component.exports